// localStorage에 값을 설정하는 함수
export function setLocalStorageItem(key: string, value: any) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error('localStorage에 값을 설정하는 중 오류가 발생했습니다:', error)
  }
}

// localStorage에서 값을 가져오는 함수. 값이 없는 경우 기본값을 반환합니다.
export function getLocalStorageItem(key: string, defaultValue = null) {
  try {
    const storedValue = localStorage.getItem(key)
    return storedValue ? JSON.parse(storedValue) : defaultValue
  } catch (error) {
    console.error('localStorage에서 값을 가져오는 중 오류가 발생했습니다:', error)
    return defaultValue
  }
}

// localStorage에서 특정 키의 값을 제거하는 함수
export function removeLocalStorageItem(key: string) {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('localStorage에서 값을 제거하는 중 오류가 발생했습니다:', error)
  }
}

// localStorage의 모든 값을 제거하는 함수
export function clearLocalStorage() {
  try {
    localStorage.clear()
  } catch (error) {
    console.error('localStorage의 모든 값을 제거하는 중 오류가 발생했습니다:', error)
  }
}
